<template>

    <v-list-tile @click.prevent="install">

        <v-list-tile-action>

            <v-avatar size="32px" tile>

                <img :src="getImgUrl('pwa_icon')">

            </v-avatar>

        </v-list-tile-action>

        <v-list-tile-content style="font-size: 13px;">

            <v-list-tile-title>{{  $t( 'reusable.install_app' ) }}</v-list-tile-title>

        </v-list-tile-content>

    </v-list-tile>

</template>

<script>

let installEvent;

export default {
    name:'PWAInstallPrompt',
    props: ['showPWAInstallPrompt','installEvent', 'isIosDevice'],
    data() {
        return {
            dialog: false
        }
    },
    computed: {
        event(){
            return this.installEvent;
        },
        show(){
            return this.showPWAInstallPrompt
        },
        IOSDevice() {
             return this.isIosDevice
        }
    },
    methods: {
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        install() {

            if ( this.IOSDevice == true ) {

                this.$emit("toggleDialog", true);
            }

            if ( this.IOSDevice == false ) {

                let tempInstallEvent = this.event;

                let showPrompt = !this.show;

                tempInstallEvent.prompt();

                tempInstallEvent.userChoice.then(() => {

                tempInstallEvent = null;

                });

                this.$emit("PromptChanged", {
                    showPWAInstallPrompt: showPrompt,
                    event: tempInstallEvent,
                });

            }

        }

    }

}
</script>

